export default function onPageLoad() {
  const loader = document.getElementById('loading-wrapper');
  if (!loader) return;
  const removeLoader = () => {
    loader.remove();
  };
  removeLoader();
}
